import lazyLoading from './modules/lazyLoading';
import navbar from "./components/navbar";
import profile from "./components/profile";
import burger from "./components/burger";

lazyLoading.init();
navbar.init();
profile.init();
burger.init();
